import SaveTemplateDialog from "./SaveTemplateDialog";
import ScheduleBuilder from "./ScheduleBuilder";
import ScheduleCard from "./ScheduleCard";
import SchedulePreview from "./SchedulePreview";
import TimeTooltip from "./TimeTooltip";
import TimingPreview from "./TimingPreview";
import TimingTable from "./TimingTable";

export const timeComponents = {
	ScheduleBuilder,
	ScheduleCard,
	TimeTooltip,
	SaveTemplateDialog,
	TimingPreview,
	TimingTable,
	SchedulePreview,
};
